import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    

     getEasternCurrentDate(): Date {
        const date = new Date();
        const easternDate = new Date(date.toLocaleString('en-US', { timeZone: 'America/New_York' }));
        return easternDate;
    }
    getDateOnly(date): string {
         const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const day = String(date.getDate()).padStart(2, '0');
    const forDateStr = `${year}-${month}-${day}`;
    return forDateStr;
        }
    

}